var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:{
    'the-checkbox': true,
    'filled': _vm.filled,
  },style:({
    '--color': _vm.color,
  })},[_c('input',{staticClass:"the-checkbox__input",attrs:{"type":"checkbox"},domProps:{"checked":_vm.value,"value":_vm.value},on:{"change":_vm.handleChange}}),_c('div',{staticClass:"the-checkbox__checkmark"},[(_vm.value)?_c('CheckIcon',{attrs:{"color":_vm.filled ? '#ffffff': _vm.color}}):_vm._e()],1),(_vm.label)?_c('div',{staticClass:"the-checkbox__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }